<template>
    <div class="shop-rec">
        <div class="part-title fix">
            <i class="icon icon-shop"></i>
            <slot name="titleText"></slot>
        </div>
        <div class="shop-list">
            <ul class="fix">
                <li v-for="item in shopRec.slice(0, 4)" :key="item.Id" @click="refresh(item.Id)">
                    <div class="pic-box">
                        <img :src="item.ImageUrl" :alt="item.Name">
                    </div>
                    <div class="text-box">
                        <p class="el">{{ item.Name }}</p>
                        <div class="price">
                            <span class="price-new">{{ item.Price }}积分</span>
                            <span class="price-old" v-if="item.OldPrice">{{ item.OldPrice }}积分</span>
                        </div>
                    </div>
                    <div class="pro-tip" v-if="tag = item.GiftTags[0]">
                        <span class="hvc" :style="`background-color: #${ tag.BackgroundColor }; color: #${ tag.FontColor }`">{{ tag.Name }}</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ShopRecV',
        props: ['rec'],
        watch: {
            'rec': function () {
                this.update()
            }
        },
        mounted () {
            this.update()
        },
        data () {
            return {
                shopRec: []
            }
        },
        methods: {
            update () {
                this.shopRec = this.rec
            },
            refresh (id) {
                this.$emit('on-refresh', id)
            }
        }
    }
</script>

<style lang="less" scoped>
    .shop-rec{
        width: 233px;
        padding: 0 10px;
        border: #d4dbde solid 1px;
        background-color: #fff;
        .part-title{
            height: 50px;
            .icon-shop{
                display: inline-block;
                vertical-align: middle;
                width: 20px;
                height: 20px;
                background: url("../../assets/images/icon_shop_rec.png") no-repeat;
                background-size: 100% 100%;
            }
            h3{
                display: inline-block;
                vertical-align: middle;
                padding-left: 9px;
                font-size: 16px;
                line-height: 50px;
            }
        }
        .shop-list{
            ul{
                li{
                    position: relative;
                    width: 100%;
                    height: 186px;
                    margin-bottom: 10px;
                    cursor: pointer;
                    &:last-child{
                        &::after{
                            display: none;
                        }
                    }
                    .pic-box{
                        height: 134px;
                        overflow: hidden;
                        img{
                            width: 100%;
                        }
                    }
                    .text-box{
                        padding-top: 5px;
                        p{
                            line-height: 20px;
                            font-size: 14px;
                        }
                        .price-new{
                            font-size: 16px;
                            color: #ffa70d;
                            line-height: 26px;
                        }
                        .price-old{
                            padding-left: 8px;
                            font-size: 12px;
                            color: #747d80;
                            line-height: 26px;
                            text-decoration: line-through;
                        }
                    }
                    .pro-tip{
                        position: absolute;
                        left: 0;
                        top: 0;
                        span{
                            width: 79px;
                            height: 24px;
                            border-bottom-right-radius: 8px;
                            color: #fff;
                            text-align: center;
                            line-height: 24px;
                        }
                    }
                }
            }
        }
    }
</style>
